/** @jsx h */
import { h } from 'preact'

import ExternalLink from '../ExternalLink'
import t from '../../../utils/translate'

const ClaimDescription = ({ title, description, url }) => (
  <section class='ModalCard-section'>
    <h3 class='ModalCard-heading'>
      {t('proof_points.js.meaning.what', { title })}
    </h3>
    <p class='ModalCard-para u-marginTop8'>{description}</p>
    {url &&
      <ExternalLink href={url}>
        {t('proof_points.js.find_more')}
      </ExternalLink>}
  </section>
)

export default ClaimDescription
